module.exports = __webpack_public_path__ + "static/media/comment.899b2849.svg";